<template>
    <v-row no-gutters>
        <v-container>
            <template>
                <v-row justify="center">
                    <v-dialog v-model="dialog" persistent max-width="400">
                        <v-progress-linear v-if="isLoading" indeterminate color="indigo darken-2"></v-progress-linear>
                        <v-card>
                            <v-card-title class="text-h5">
                                Konfirmasi
                            </v-card-title>
                            <v-card-text style="min-height: 50px;">Apakah anda yakin isian anda sudah benar?</v-card-text>
                            <v-card-actions class="justify-content-center">
                                <v-spacer></v-spacer>
                                <v-btn :disabled="isLoading" color="indigo darken-4" text @click="onCloseDialog(false)">
                                    Batal
                                </v-btn>
                                <v-btn :disabled="isLoading" color="indigo darken-4 white--text"
                                    @click="onCloseDialog(true)">
                                    Simpan
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-card class="p-4">
                    <v-form ref="addRubric" v-model="addRubric" lazy-validation>
                        <h6 class="text-body-1 pb-5 indigo--text text--darken-4">Tambah rubrik<v-icon
                                class="indigo--text text--darken-4">mdi-chevron-right</v-icon></h6>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field filled background-color="white" v-model="formRubric.nama"
                                    :rules="$rules.required" solo dense required>
                                    <template #label>
                                        Nama rubrik<span class="red--text"><strong>* </strong></span>
                                    </template></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-row>
                                    <v-simple-table>
                                        <template>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        No.
                                                    </th>
                                                    <th class="text-left">
                                                        Komponen
                                                    </th>
                                                    <th class="text-left">
                                                        Bobot
                                                    </th>
                                                    <th class="text-left">
                                                        Aksi
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in komponen">
                                                    <td color="indigo--text text--darken-4">{{ index + 1 }}</td>
                                                    <td>
                                                        <v-textarea flat rows="1" :auto-grow="true" :full-width="true"
                                                            v-model="komponen[index].nama" :hide-details="true"
                                                            :rules="$rules.required" solo required
                                                            placeholder="Nama komponen"></v-textarea>
                                                    </td>
                                                    <td><v-text-field flat :hide-details="true" :auto-grow="true"
                                                            :full-width="true" v-model="komponen[index].bobot"
                                                            :rules="$rules.required" solo required
                                                            placeholder="Bobot"></v-text-field></td>
                                                    <td>
                                                        <v-chip class="ma-2" color="red darken-4" label text-color="white">
                                                            <v-icon color="dark" @click="onDeleteItem(item)">
                                                                mdi-minus
                                                            </v-icon>
                                                        </v-chip>

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td color="indigo--text text--darken-4"></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>
                                                        <v-chip class="ma-2" color="light-blue darken-4" label
                                                            text-color="white">
                                                            <v-icon color="dark" @click="addComponent()">
                                                                mdi-plus
                                                            </v-icon>
                                                        </v-chip>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-row>
                            </v-col>
                        </v-row>
                        <div class="d-flex justify-content-center mt-5">
                            <v-btn outlined class="m-2" color="primary" @click="buttonBackClick()">
                                Kembali
                            </v-btn>
                            <v-btn class="m-2" color="primary" @click="dialog = true">
                                Simpan
                            </v-btn>
                        </div>
                    </v-form>
                </v-card>
            </template>
        </v-container>
    </v-row>
</template>

<script>
import { serialize } from "object-to-formdata";
export default {
    data() {
        return {
            formRubric: {
                nama: undefined,
            },
            komponen: [],
            addRubric: true,
            dialog: false,
            isLoading: false,
            idRubrik: undefined
        }
    }, created() {
        if (this.$route.query.update){ 
            this.FORM_STATUS = 'update';
            this.idRubrik = this.$route.query.update;
            this.getData();
        } else {
            this.komponen.push(
                {
                    nama: undefined,
                    bobot: undefined,
                })
        };
    },
    methods: {
        getData() {
            this.isLoading = true;
            this.axios.get("/api/rubrik/"+ this.idRubrik).then((res) => {
                this.formRubric = res.data.data;
                this.formRubric.nama = this.formRubric.nama_rubrik;
                this.formRubric.komponen_penilaian.forEach(el => {
                    this.komponen.push(el);
                });
            }).finally(() => this.isLoading = false);
        },
        onDeleteItem(row) {
            let editedIndex = this.komponen.indexOf(row)
            if (this.komponen.length == 1 && editedIndex == 0) {
                this.komponen.push({
                    nama: null,
                    komponen: null
                })
            }
            this.komponen.splice(editedIndex, 1)
        },
        addComponent() {
            this.komponen.push(
                {
                    nama: null,
                    bobot: null
                }
            )
        },
        buttonBackClick() {
            this.$router.push({ name: "manage-rubric.index" });
        },
        onCloseDialog(event) {
            if (event == true) {
                this.submit();
                this.dialog = false
            } else {
                this.dialog = false;
            }
        },
        submit() {
            console.log('tes');
            let url = "/api/rubrik";
            const valid = this.$refs.addRubric.validate();
            if (valid) {
                this.isLoading = true;
                const options = {
                    indices: false,
                    nullsAsUndefineds: true,
                    booleansAsIntegers: false,
                    allowEmptyArrays: false,
                    noFilesWithArrayNotation: false,
                    dotsForObjectNotation: false,
                };
                if (this.FORM_STATUS === "update") {
                    this.formRubric["_method"] = "put";
                    url = "/api/rubrik/" + this.idRubrik;;
                }
                let formData = new FormData();
                formData = serialize(this.formRubric, options);
                if (this.komponen.length > 0) 
                this.komponen.forEach((el, i) => {
                    formData.append('komponen['+i+'][nama]', el.nama);
                    formData.append('komponen['+i+'][bobot]', el.bobot);
                });
                this.axios
                    .post(url, formData)
                    .then((res) => {
                        this.$emit("toast", "success", "Berhasil menyimpan data");
                        this.$router.push({ name: "manage-rubric.index" });
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },
    }
}
</script>